import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select, Button, DatePicker, Tooltip, Icon, Dropdown, Menu } from 'antd';

import Grid from '@material-ui/core/Grid';
import { styles, useStyles } from './OnSiteEvaluationsFormStyles';
import TextEvents from 'app/components/TextEvents';

import TableContainer from 'app/containers/TableContainer';
import ApiService from 'app/services/ApiService';
import moment from 'moment';

import { getOnSiteEvaluationsFilters, getIsLoadingOnSiteEvaluationsilters } from 'app/reducers';
import { getEvaluationsFtF, exportEvaluationFtF } from 'app/actions/OnSiteEvaluationsActions';



const { Option } = Select;

// const SelectItem = (name = [], value) => {
//     let x = name[value]
//     return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

// }

const SelectItem_ = (name = [], value) => {
    if (name == null) name = [];

    if (name.length === 0) {
        return <Option disabled key={'cargando'}>No existen valores..</Option>;
    }

    return (
        name.map((item) =>
            <Select.Option key={`${item}`} value={`${item}`}>{item}</Select.Option>
        )
    );
}



export default function OnSiteEvaluationsForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [collapse, setCollapse] = useState(true);
    //const { name } = useSelector(state => state.OnSiteEvaluations.OnSiteEvaluationsFilters);
    const { idSubdirection, employeeId } = useSelector((state) => state.Auth.employeeById);
    const { isExportingF } = useSelector((state) => state.OnSiteEvaluations)

    let [procedureSelected, setProcedure] = useState([]);
    let [codeSelected, setCode] = useState([]);
    let [folioSelected, setFolio] = useState([]);
    let [trainingSelected, setTraining] = useState([]);
    const [loading, setLoading] = useState(false);

    let evaluationsfilters = useSelector(getOnSiteEvaluationsFilters);

    const obj = {
        SubdirectionId: idSubdirection,
        CourseCode: codeSelected,
        CourseName: procedureSelected,
        EmployeeId: employeeId,
        Trainings: trainingSelected,
        CourseFolio: folioSelected,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    };

    const search = () => {
        dispatch(getEvaluationsFtF(obj));
        props.setFormData(obj);
    }

    const finishExporting = () => {
        setLoading(false);
    }



    const exportar = async () => {
    
        setLoading(true);
        var payload = {
            SubdirectionId:idSubdirection,
            CourseCode: codeSelected,
            CourseName: procedureSelected,
            EmployeeId: employeeId,
            Trainings: trainingSelected,
            CourseFolio: folioSelected,
        }
        var todayDate = new Date().toISOString().slice(0, 10);
        dispatch(exportEvaluationFtF(payload, todayDate, finishExporting));
        //setLoading(false);

    }

    return (
        <div>
            <TableContainer>
                {
                    (params) => {
                        return (
                            <div>
                                {/* {JSON.stringify(evaluationsfilters)} */}
                                <div hidden={collapse}>

                                    <Grid container direction="row">
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Procedimiento/Material de capacitación"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Procedimiento/Material de capacitación"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setProcedure}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.name)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Código"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Codigo"
                                                onChange={setCode}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.code)
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row">
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Folio"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Folio"
                                                onChange={setFolio}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.folio)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Tipo de Capacitacion"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Tipo de Capacitacion"
                                                onChange={setTraining}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.trainings)
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div
                                    className={classes.container}
                                    style={styles.baseVerticalMargin}
                                >
                                    {
                                        collapse ?
                                            <Tooltip title={"Mostrar filtro"}>
                                                <Button
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="link"
                                                    onClick={() => setCollapse(false)}
                                                >
                                                    <Icon type="down" />
                                                </Button>
                                            </Tooltip> :
                                            <Tooltip title={"Ocultar filtro"}>
                                                <Button
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="link"
                                                    onClick={() => setCollapse(true)}
                                                >
                                                    <Icon type="up" />
                                                </Button>
                                            </Tooltip>
                                    }
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        onClick={search}
                                    >
                                        Buscar
                                    </Button>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        onClick={exportar}
                                        loading={loading}
                                    >
                                        Exportar
                                    </Button>
                                </div>
                            </div>

                        )
                    }
                }
            </TableContainer>
        </div>
    )
}